module.exports = __webpack_public_path__ + "files/03c67e422c0f689e3d7589ef8589820c.svg";